const updateProgressBar = () => {
  const progressBar = document.querySelector( '.progress-bar' );

  if (!progressBar) {
    return;
  }

  const progressBarFill = progressBar.querySelector( '.progress-bar__fill' );

  if (!progressBarFill) {
    return;
  }

  const scrollPosition = window.scrollY;
  const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
  const progress = (scrollPosition / windowHeight) * 100;

  progressBarFill.style.inlineSize = `${progress}%`;
}

const init = () => {
  window.addEventListener( 'scroll', updateProgressBar );
}

export default init;